import {ModalStateType} from "../interface";
import {atom} from "jotai";

/**
 * 초기 모달 값
 */
export const initialModalState: ModalStateType = {
    isOpen: false,
    contents: null,
    type: "",
    depth: 1,
    callback: () => {
        // default callback
    },
    closeAction: () => {
        // default close action
    },
    className: "",
    title: "",
    noHeader: false,
    noCloseBtn: false,
    modalSize: `sm`,
};

export const modal_state_atom1 = atom(initialModalState);
export const modal_state_atom2 = atom(initialModalState);
export const modal_state_atom3 = atom(initialModalState);
export const modal_state_atom4 = atom(initialModalState);
export const modal_state_atom5 = atom(initialModalState);
